import { createApp } from 'vue';
import './plugins/assets';
import { setupDayjs, setupIconifyOffline, setupLoading, setupNProgress } from './plugins';
import { setupStore } from './store';
import { setupRouter } from './router';
import App from './App.vue';
import directives from './directive/index ';
import './components/form-design/styles/index.scss';

import VueCropper from 'vue-cropper';
import 'vue-cropper/dist/index.css'

async function setupApp() {
  setupLoading();

  setupNProgress();

  setupIconifyOffline();

  setupDayjs();

  const app = createApp(App);

  app.use(directives);

  setupStore(app);

  await setupRouter(app);

  app.use(VueCropper)

  // app.config.errorHandler = (err, vm, info) => {
  //   console.error(err, vm?._, info)
  // }
  // app.config.warnHandler = (err, vm, info) => {
  //   console.warn( info)
  // }

  app.mount('#app');
}

setupApp();
